import React, { useRef, useEffect, useState } from "react";
import FormField from "./FormField"; // optional

const EnquiryForm = ({ formFields, setSuccessMessage }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const errorRef = useRef(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 0);
    }
  }, [error]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);
    setIsSubmitting(true);
    let isSuccess = false;
    let result = null;
    try {
      const response = await fetch(window.gmpqcw_wp_ajax.enquiry, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": window.gmpqcw_wp_ajax.nonce,
        },
        body: JSON.stringify(formData),
      });

      result = await response.json();

      if (result.msg === "success") {
        isSuccess = true;
        setSuccessMessage("Enquiry successfully submitted!");
        //console.log(result);
        if (result.redirect === "yes") {
          window.location.href = result.redirect_to;
        }
      } else {
        const errorHtml = result.returnhtml || "An error occurred while submitting the enquiry.";
        setError(errorHtml);
      }
    } catch (error) {
      setError("Error submitting enquiry. Please try again later.");
    } finally {
      setIsSubmitting(false);
      // Dispatch custom event regardless of success/failure
      const event = new CustomEvent("Gm_quote_cart_submitted", {
        detail: {
          success: isSuccess,
          formData,
          result,
        },
      });
      window.dispatchEvent(event);
    }
  };

  return (
    <div className="gmpqcw-form">
      {window.gmpqcw_wp_ajax.gmpqcw_content_beforeform && (
        <div className="gmpqcw-form-before-content">
          {window.gmpqcw_wp_ajax.gmpqcw_content_beforeform}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {formFields.map((field) => (
          <FormField
            key={field.name}
            field={field}
            value={formData[field.name]}
            onChange={handleChange}
          />
        ))}

        <button className="gmpqcw-submit-btn" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <span className="gmpqcw-loader">Submitting...</span>
          ) : (
            window.gmpqcw_wp_ajax.gmpqcw_translation?.gmpqcw_trasnlation_button_label?.val || "Submit"
          )}
        </button>
      </form>

      {error && (
        <div
          ref={errorRef}
          className="gmpqcw-error"
          dangerouslySetInnerHTML={{ __html: error }}
        />
      )}

      {window.gmpqcw_wp_ajax.gmpqcw_content_afterform && (
        <div className="gmpqcw-form-after-content">
          {window.gmpqcw_wp_ajax.gmpqcw_content_afterform}
        </div>
      )}
    </div>
  );
};

export default EnquiryForm;
